import type PopperJS from '@popperjs/core';

import { isRtlEnabled } from '@gem/utils';

const rtlPlacementMap: Record<PopperJS.Placement, PopperJS.Placement> = {
  auto: 'auto',
  'auto-start': 'auto-start',
  'auto-end': 'auto-end',

  top: 'top',
  'top-start': 'top-start',
  'top-end': 'top-end',

  bottom: 'bottom',
  'bottom-start': 'bottom-start',
  'bottom-end': 'bottom-end',

  left: 'right',
  'left-start': 'right-start',
  'left-end': 'right-end',

  right: 'left',
  'right-start': 'left-start',
  'right-end': 'left-end',
};

export const getPlacement = (placement: PopperJS.Placement): PopperJS.Placement =>
  isRtlEnabled() ? rtlPlacementMap[placement] : placement;
